module.exports = __webpack_public_path__ + "img/icon-ekyc-detail-faq-arrow.92fea7a.svg";